import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Update.module.less';
import { PCStoreJsBridge } from '../../../nativeapi';
import Toast from '../../../components/Toast/Toast';
import { logging } from '../../../actions/log';

import { cacheKeys } from '../../../constants/storageKeys';
import { localSetItem } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const [controlInfo, setControlInfo] = useState({});

  const logInfoData = useSelector(selectLogInfo);

  const handleChoose = useCallback(
    info => {
      const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
      PCStoreJsBridge.settingRightMenu({
        enable: startInfo.rightMenuInfo.enable,
        source: 1,
        wallpaperEnable: startInfo.rightMenuInfo.wallpaperEnable,
        recommendEnable: !info.recommendEnable,
      }).then(res => {
        if (res.succ === 'true') {
          setControlInfo({
            recommendEnable: !info.recommendEnable,
            wallpaperEnable: info.wallpaperEnable,
            cloudEnable: info.cloudEnable,
          });
          let Info = {
            ...startInfo,
            rightMenuInfo: {
              enable: startInfo.rightMenuInfo.enable,
              source: 1,
              wallpaperEnable: startInfo.rightMenuInfo.wallpaperEnable,
              recommendEnable: !info.recommendEnable,
              cloudEnable: true,
            },
          };
          localStorage.setItem('START_INFO', JSON.stringify(Info));
          Toast.success({
            content: '设置成功!',
          });
        }
      });

      dispatch(
        logging({
          category: 'C',
          action: 'Tankuang_Enabled',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            enabled: !info.recommendEnable,
            type: 14,
          },
        }),
      );
    },
    [controlInfo],
  );

  // 修改右键评分设置的默认值
  useEffect(() => {
    PCStoreJsBridge.getRightMenuInfo().then(res => {
      if (res.succ) {
        setControlInfo(res);
      }
    });
  }, []);

  return (
    <div className={styles.s_update}>
      {controlInfo && controlInfo.cloudEnable && (
        <div className="s_line">
          <div className="s_select_title">右键菜单:</div>
          <div className="s_content">
            <div className="checkbox checkbox_clear" onClick={() => handleChoose(controlInfo)}>
              {controlInfo.recommendEnable ? (
                <div className="checked" />
              ) : (
                <div className="no_checked" />
              )}
              <span>开启右键快捷方式</span>
            </div>
            <div className="desc desc_margin_top">建议您开启，快速更新和评价应用</div>
          </div>
        </div>
      )}
    </div>
  );
});
